import { render, staticRenderFns } from "./halogen-kohlenwasserstoffe.vue?vue&type=template&id=2aa362fa&"
import script from "./halogen-kohlenwasserstoffe.vue?vue&type=script&lang=js&"
export * from "./halogen-kohlenwasserstoffe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports